module.exports = {
  ArrayUtil: require('./tools/array-util'),

  DelayUpdater: require('./tools/delay-updater'),
  DelayWorker: require('./tools/delay-worker'),
  useDelayWorker: require('./tools/delay-worker').useDelayWorker,

  DateUtil: require('./tools/date-util'),
  NumberUtil: require('./tools/number-util'),

  // ApiSwitch : require('./tools/api-switch').ApiSwitch,
  isEmail: require('./tools/is-email').isEmail,

  checkRequiredProperty: require('./tools/json-util').checkRequiredProperty,
  jsonToQueryString: require('./tools/json-util').jsonToQueryString,
};
